import { render, staticRenderFns } from "./BCXMessengerCollapsible.vue?vue&type=template&id=1104a6f2&scoped=true"
import script from "./BCXMessengerCollapsible.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerCollapsible.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerCollapsible.vue?vue&type=style&index=0&id=1104a6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1104a6f2",
  null
  
)

export default component.exports